import axios from 'axios';

const API_BASE_URL = "https://backend-d6mx.vercel.app"

// Create axios instance with base URL
const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true // This is crucial for cookies to be sent/received
});

// Request interceptor - attach Bearer token if present
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor for handling errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle 401/403 errors (token expired or unauthorized)
        if (error.response?.status === 401 || error.response?.status === 403) {
            // Clear any cached user data - let AuthContext and ProtectedRoute handle redirects
            localStorage.removeItem('vendorUser');
        }
        return Promise.reject(error);
    }
);


// Export the API_BASE_URL and axios instance
export { api };
export default API_BASE_URL;

